import styled from 'styled-components'

import { Align } from './common.types'

interface Props {
    align?: Align
    flex?: string | number
}

export const PageSectionBlock = styled.div.attrs(({ className }) => ({
    className: 'fic-page-section-block ' + className,
}))<Props>`
  text-align: ${props => props.align};
  float: ${props => (props.align === 'center' ? 'none' : props.align)};
  display: inline-block;
  margin-top: 8px;
  vertical-align: middle;
  flex: ${props => props.flex};
  a.btn-flat + a.btn-flat {
    margin-left: 8px;
  }
`

PageSectionBlock.defaultProps = {
    align: 'center',
    flex: undefined,
}
